import { useState, useEffect } from "react";

// react-router components
import { Link, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Icon from "@mui/material/Icon";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 MUI example components
import Breadcrumbs from "examples/Breadcrumbs";

// Custom styles for DashboardNavbar
import {
    navbar,
    navbarContainer,
    navbarIconButton,
    navbarDesktopMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Argon Dashboard 2 MUI context
import {
    useArgonController,
    setTransparentNavbar,
    setMiniSidenav,
} from "context";
import userStore from "store/userStore";
import { Avatar, IconButton, List, ListItem, ListItemAvatar, ListItemText, Menu, MenuItem } from "@mui/material";
import { navbarMobileMenu, navbarRowLeft, navbarRowRight } from "./styles";

import logo from "assets/images/logo-buton.png";
import { postDataWithResponse } from "global/postFunc";

function DashboardNavbar({ absolute, light, isMini, user, dinas, homePage, loginId }) {
    const [navbarType, setNavbarType] = useState();
    const [controller, dispatch] = useArgonController();
    const { miniSidenav, transparentNavbar, fixedNavbar, darkMode } = controller;
    // const route = useLocation().pathname.split("/").slice(1);

    useEffect(() => {
        // Setting the navbar type
        if (fixedNavbar) {
            setNavbarType("sticky");
        } else {
            setNavbarType("static");
        }

        // A function that sets the transparent state of the navbar.
        function handleTransparentNavbar() {
            setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
        }

        /** 
         The event listener that's calling the handleTransparentNavbar function when 
         scrolling the window.
        */
        window.addEventListener("scroll", handleTransparentNavbar);

        // Call the handleTransparentNavbar function to set the state with the initial value.
        handleTransparentNavbar();

        // Remove event listener on cleanup
        return () => window.removeEventListener("scroll", handleTransparentNavbar);
    }, [dispatch, fixedNavbar]);

    const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

    const logOut = userStore((state) => state.logOut)
    const navigate = useNavigate();

    const handleLogout = () => {
        postDataWithResponse(
            '/auth/logout',
            {
                // username: username,
                id: loginId
            },
            null,
            afterSubmit,
            null
        )
    }

    const afterSubmit = (data) => {
        console.log(data);
        if (data > 0) {
            logOut();
            navigate("/", { replace: true });
        }
        handleClose()
    }

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <AppBar
            position={absolute ? "absolute" : navbarType}
            color="inherit"
            sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
        >
            <Toolbar sx={(theme) => navbarContainer(theme, { navbarType })}>
                <ArgonBox
                    color={darkMode ? 'white' : (light && transparentNavbar ? "white" : "dark")}
                    mb={{ xs: 1, md: 0 }}
                    sx={(theme) => navbarRowLeft(theme, { isMini })}
                >
                    <Icon fontSize="medium" sx={navbarDesktopMenu} onClick={handleMiniSidenav}>
                        {miniSidenav ? "menu_open" : "menu"}
                    </Icon>
                    <Breadcrumbs
                        icon="home"
                        light={transparentNavbar ? light : false}
                        homePage={homePage}
                    />
                </ArgonBox>
                <ArgonBox sx={(theme) => navbarRowRight(theme, { isMini })}>
                    <IconButton
                        size="small"
                        color={light && transparentNavbar ? "white" : "dark"}
                        sx={navbarMobileMenu}
                        onClick={handleMiniSidenav}
                    >
                        <Icon>{miniSidenav ? "menu_open" : "menu"}</Icon>
                    </IconButton>
                    <ArgonBox color={light ? "white" : "inherit"}>
                        <List
                            aria-label="Device settings"
                        >
                            <ListItem
                                sx={navbarIconButton}
                                // size="small"
                                // id="lock-button"
                                // aria-haspopup="listbox"
                                // aria-controls="lock-menu"
                                // aria-label="when device is locked"
                                // aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick}
                            >
                                <ListItemText
                                    // primaryTypographyProps={{
                                    //     justifyContent: 'flex-end'
                                    // }}
                                    primary={
                                        <ArgonTypography
                                            variant="button"
                                            fontWeight="medium"

                                            color={light && transparentNavbar ? "white" : "dark"}
                                            px={1}
                                            textAlign='right'
                                        >
                                            {user || ''}
                                        </ArgonTypography>
                                    }
                                    secondary={
                                        <ArgonTypography
                                            variant="button"
                                            fontWeight="regular"
                                            color={light && transparentNavbar ? "white" : "dark"}
                                            px={1}
                                            textAlign='right'
                                        >
                                            {dinas || ""}
                                        </ArgonTypography>
                                    }
                                />
                                <ListItemAvatar sx={{
                                    textAlign: 'right'
                                }}>
                                    <Avatar alt="Logo" src={logo} />
                                </ListItemAvatar>
                            </ListItem>
                        </List>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <MenuItem onClick={handleClose}>
                                <Link to={homePage+"/profil"}>
                                    Profil
                                </Link>
                            </MenuItem>
                            <MenuItem onClick={handleLogout}>Logout</MenuItem>
                        </Menu>
                    </ArgonBox>
                </ArgonBox>
            </Toolbar>
        </AppBar>
    );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
    absolute: false,
    light: true,
    isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
    absolute: PropTypes.bool,
    light: PropTypes.bool,
    isMini: PropTypes.bool,
};

export default DashboardNavbar;
